/* eslint-disable no-prototype-builtins */
/* eslint-disable security/detect-object-injection */
import messages from './messages'
import messagesBeta from './messagesBeta'
import checkerFactory from './checkerFactory'

const constants = {
  string: 'string',
}
const supportedProps = {
  string: [
    'required',
    'dropRequire',
    'min',
    'max',
    'maxNewLine',
    'compare',
    'phone',
    'phoneMask',
    'email',
    'zipcode',
    'reCaptcha',
    'maxCounter',
    'maxCounterNewLine',
    'poBox',
  ],
}

const getSchemaType = (type, schema) => {
  const types = supportedProps[type]
  return types.reduce((dataObject, typeInstance) => {
    if (schema.hasOwnProperty(typeInstance)) {
      dataObject[typeInstance] = schema[typeInstance]
    }
    return dataObject
  }, {})
}

const validateData = (schemaProps, value, schema, propKey, data) => Object.entries(schemaProps).reduce((errors, [key, schemaValue]) => {
  const messageKey = schemaProps.required && !value ? 'required' : key
  const hasError = checkerFactory[messageKey](schemaValue, value, data)
  if (hasError) {
    const errorMessage = messagesBeta[messageKey]
    errors[propKey] = schema.message
        || errorMessage
          .replace('{{label}}', schema.label || propKey)
          .replace('{{length}}', schemaValue)
          .replace(
            '{{extra}}',
            parseInt(schemaValue, 10) - (value || '').length,
          )
  }
  return errors
}, {})

const validate = (data, schema = {}) => {
  const errorStack = Object.entries(schema).reduce((errors, [key, field]) => {
    const dataType = field.type || constants.string
    const value = data[key]

    const schemaProps = getSchemaType(dataType, field)
    const errorInstance = validateData(schemaProps, value, field, key, data)
    return { ...errors, ...errorInstance }
  }, {})
  return Object.keys(errorStack).length ? errorStack : false
}

export default validate
